export const integration = {
  menu: {
    title: 'API Интеграция',
    v1: 'Интеграция v1 (deprecated)',
    v2: 'Интеграция v2'
  },
  breadcrumb: {
    title: 'API Интеграция',
    api: 'API',
    general: 'Обзор',
    user: 'Пользователь',
    sms: 'Отправлять сообщения',
    'get-state': 'Получить состояние рассылки',
    database: 'Базы данных',
    'group-database': 'Группы баз данных',
    statistic: 'Статистика',
    phones: 'Телефонные номера'
  },
  api: {
    answer_example: 'Пример ответа:',
    api_integration: 'API Интеграция',
    api_requests:
      'Все запросы API требуют токен доступа. Вы можете получить его, используя запрос <b>auth/login</b>',
    authorization: 'Авторизация',
    because_recipient_hard:
      'потому что для этого получателя трудно установить текст сообщения с помощью',
    combined_sending: 'Комбинированная отправка',
    create_db: 'Создать базу данных',
    create_group: 'Создать группу',
    databases: 'Базы данных',
    example: 'Пример:',
    get_all_databases: 'Получить все базы данных',
    get_all_groups: 'Получить все группы',
    get_mailing_list: 'Получить список рассылок',
    get_mailing_state: 'Получить состояние рассылки',
    get_message_state: 'Получить состояние сообщения',
    group_db: 'Группы баз данных',
    import: 'Импорт получателей',
    limit_recipients:
      'Этот запрос отправит «hello» всем получателям в списке. <b> Максимальное количество получателей в одном запросе составляет 1000 </b>',
    list_macros: 'Список возможных макросов в рассылке',
    macros_replace_recipient:
      'Макросы, используемые для замены части сообщения динамическими данными, связанными с получателем.',
    mailing: 'Рассылка',
    not_specify_name_field: 'потому что он не указано поле name',
    on_phone_number: 'на номер телефона',
    optional_element_custom_message:
      'Вы можете использовать дополнительный элемент custom_message, чтобы жестко задавать текст сообщения для конкретного получателя.',
    overview: 'Обзор',
    phones: 'Телефонные номера',
    phones_unoccupied: 'Свободные телефонные номера',
    recipients_macros: 'Отправка сообщения нескольким получателям с помощью макросов',
    request_header:
      'В ответ вы получите токен, который должен быть указан в заголовке другого запроса.',
    request_send_messages: 'Этот запрос отправит сообщение',
    send_message_limit: 'Ограничение на количество запросов в минуту: ',
    send_messages: 'Отправлять сообщения',
    send_messages_group: 'Отправка сообщения нескольким получателям',
    send_single_messages: 'Отправка сообщения одному получателю',
    stat_mailing: 'Статистика по рассылке',
    stat_sms: 'Статистика по SMS',
    stat_voice: 'Статистика по звонкам',
    statistics: 'Статистика',
    user: 'Пользователь',
    user_info: 'Информация о пользователе',
    what_api: 'Что такое ZORRA API?',
    zorra_api_text:
      'ZORRA API&nbsp;&mdash; это простой метод использования некоторых функций нашего сервиса с&nbsp;вашими собственными приложениями. Вы&nbsp;можете использовать API для отправки сообщений, получения состояний рассылки и&nbsp;т.&nbsp;д.'
  },

  v2: {
    breadcrumb: {
      title: 'API Интеграция',
      api: 'API',
      general: 'Обзор',
      token: 'Обновление токена',
      user: 'Информация о пользователе',
      sms: 'SMS рассылки',
      verification: 'Верификация номеров',
      databases: 'Базы данных',
      hlr: 'HLR запросы'
    },

    1: 'Все запросы API требуют токен доступа. Вы можете получить его, используя запрос auth/login',
    2: 'Параметр remember - отвечает за продолжительность жизни токена, который вы получите в ответ. При "remember": false - время жизни токена 1 час, при "remember": true - 30 дней и 10 ч. Параметр не является обязательным при запросе и по умолчанию будет принят в значении false.',
    3: 'Параметр expires_in сообщает время жизни токена в секундах.',
    4: 'Обновление токена',
    5: 'После получения первого токена, вы можете обновить его используя метод refresh. Сделать это можно только при наличии токена с еще не истекшим временем жизни. Он будет уничтожен, а в ответ вы получите новый с временем жизни в 10 часов.',
    6: 'Этот метод позволяет получить информацию о вашем аккаунте. В заголовке необходимо передать токен, полученный через метод auth/login.',
    7: 'SMS рассылки',
    8: 'Обратите внимание, что совершать рассылки можно только после того, как вы отправите на модерацию хотя бы одно имя отправителя (sender), и оно получит одобрение.',
    9: 'Отправка сообщения одному получателю',
    10: 'Этот запрос отправит сообщение из body ("hello”) на номер телефона из recipient в дату и время, указанное в start_at.',
    11: 'зарегистрированный сендер в Zorra; обязательный параметр, текстовое поле',
    12: 'название рассылки ; необязательный параметр ; если не указано, то название генерируется автоматически с указанием даты, времени, текстовое поле',
    13: 'сообщение в рассылке; обязательный параметр, текстовое поле',
    14: 'получатель; обязательный параметр',
    15: 'необязательное текстовое поле; используется для указания даты отправки отложенной рассылки. Формат yyyy-mm-dd hh:mm:ss',
    16: 'Отправка сообщения нескольким получателям',
    17: 'Этот запрос отправит «Hello» всем получателям в списке базы данных id = 3759 и номерами записей в ней от 1 до 10 + на номер из',
    18: 'Метод схож с отправкой одному получателюлю, отличается полем',
    19: 'массив json объектов с базами и диапазоном для указания конкретных получателей, необязательный параметр',
    20: 'id базы данных для включения в рассылку',
    21: 'указание диапазона номеров которые будут включаться в рассылку',
    22: 'первый номер базы, включенный в рассылку',
    23: 'последний номер базы, включенный в рассылку',
    24: 'Например есть база с 3 получателями:',
    25: 'Для того чтобы отправить смс Мише и Андрею следует указать range from: 1 to: 2, границы включены Если отправить всем троим, то передадим range from 1 to 3',
    26: 'применяется для исключения получателей из рассылки, необязательный параметр',
    27: 'дополнительный получатели; массив JSON объектов',
    28: 'Использование макросов в сообщениях',
    29: 'Вы можете сделать свою рассылку более персонифицированной, используя макросы в тексте сообщений. Это набор переменных, которые можно предзаполнить для контактов в ваших базах данных, чтобы подставлять уникальное значение для каждого получателя. Например, вы можете заполнить имя клиента для каждого номера в вашей бд и добавить именное приветствие в сообщение.',
    30: 'Пример использования макроса:',
    31: 'В итоге на номер 79999999999 будет отправлено сообщение с текстом: “Hello Анатолий. I am from Владикавказ”, а на номер 71111111111 - “Hello Antony. I am from New York”.',
    32: 'Для базы данных, вы можете заранее заполнить необходимы поля контактов, значение которых будет подставляться в макросы.',
    33: 'Кастомное сообщение для части получателей',
    34: 'Вы можете использовать дополнительный элемент custom_message, чтобы жестко задавать текст сообщения для конкретного получателя.',
    35: 'Этот запрос отправит «Greetings!» на номер телефона 79123456789, потому что для этого получателя установлен текст сообщения с помощью custom_message,',
    36: 'будет отправлено на номер телефона 79992223333,',
    37: 'уйдет на номер телефона 79997777777, потому что для него не указано поле name или custom_message.',
    38: 'Получение состояния рассылок',
    39: 'Можно использовать фильтры:',
    40: 'название рассылки',
    41: 'статус рассылки',
    42: 'дата создания рассылки',
    43: 'способ отправки запроса, возможные значения - web, api',
    44: 'Для фильтрации нужно передать в body JSON с необходимыми параметрами и их значениями.',
    45: 'Пример body:',
    46: 'Получение состояния смс-сообщений',
    47: 'Параметры в данном методе выступают в роли фильтров, передавать все не обязательно.',
    48: 'Подробнее о параметрах:',
    49: 'дата ОТ',
    50: 'дата ДО',
    51: 'фильтр по названию рассылки',
    52: 'фильтр по идентификатору рассылки',
    53: 'фильтр по номеру',
    54: 'фильтр по статусу. Возможные значения: ',
    55: 'фильтр по имени отправителя, в ответе поле называется',
    56: 'направление сортировки',
    57: 'поле для сортировки',
    58: 'Общая статистика рассылок',
    59: 'Параметры в данном методе выступают в роли фильтров, передавать все не обязательно.',
    60: 'Подробнее о параметрах: ',
    61: 'указание группировки. Возможные значения: ',
    62: 'обязательный параметр',
    63: 'Фильтр по источнику отправки. Возможные значения:',
    64: 'фильтр по имени отправителя',
    65: 'пагинация',
    66: 'направление сортировки',
    67: 'поле для сортировки',
    68: 'Верификация номеров',
    69: 'Верификация номеров - удобная функция, которая позволяет проверить, что номер телефона существует и принадлежит человеку, который его предоставил. Zorra предоставляет 4 способа верификации: по смс, по последним цифрам входящего номера, по коду продиктованному при звонке, по звонку на исходящий номер.',
    70: 'Верификация по смс',
    71: 'На номер, который требуется проверить, будет отправлена смс с уникальным кодом. Далее пользователь вводит полученный код, если он совпадает с отправленным - номер верифицирован.',
    72: 'После данного запроса на номер 79123456789 поступит смс в формате “Code: 123”. В соответствии с тем, что указано в code.',
    73: 'номер, который нужно верифицировать, на него будет отправлено смс',
    74: 'обязательный параметр',
    75: 'если передать этот параметр, то указанный код придет в смс. Если параметр не указан, то мы сами генерируем код, размером size (6 символов, если не указано иное)',
    76: 'параметр который указывает какой длины генерировать код, если параметр code не задан, если код задан вручную, то передавать не нужно',
    77: 'параметр для удобства отслеживания результатов',
    78: 'идентификатор запроса верификации',
    79: 'тип верификации',
    80: 'верифицируемый номер',
    81: 'параметр указывающий на то, на чьей стороне был задан code. В данном случае code передавали в запросе, поэтому считаем что он сгенерирован вручную, а не на стороне Zorra, поэтому true',
    82: 'регион',
    83: 'Для проверки кода вы можете использовать метод:',
    84:'Обратите внимание, что метод check работает только для случаев, где код был сгенерирован автоматически.',
    85: 'Время жизни отправленного кода - 5 минут, после он становится невалидным',
    86: 'В теле запроса нужно передать номер телефона, на который отправлялся код и сам код введенный пользователем, чтобы сверить с отправленным.',
    87: 'Пример ответа, если введен правильный код:',
    88: 'Пример ответа, если введен неправильный код:',
    89: 'Верификация по последним цифрам номера',
    90: 'На номер, который требуется проверить, будет произведен входящий звонок с уникального номера. Далее пользователь должен ввести определенное количество последних цифр номера, с которого поступил звонок, если они совпадают с номером звонка, то номер пользователя - верифицирован.',
    91: 'После данного запроса на номер 79123456789 поступит звонок с номера, оканчивающегося на 12345, как указано в code.',
    92: 'номер, который нужно верифицировать, на него поступит звонок, обязательный параметр.',
    93: 'если передать этот параметр, то звонок будет с номера, оканчивающегося на заданные цифры. Если параметр не указан, то мы сами генерируем цифры в номер, размером ',
    94: '(6 символов, если не указано иное)',
    95: 'параметр указывает сколько цифр надо сгенерировать в номер, если параметр',
    96: 'не задан. Если код задан вручную, то передавать не нужно.',
    97: 'параметр для удобства отслеживания результатов, по умолчанию “en”.',
    98: 'идентификатор запроса верификации',
    99: 'тип верификации',
    100: 'верифицируемый номер',
    101: 'параметр указывающий на то, на чьей стороне был задан code. В данном случае code передавали в запросе, поэтому считаем что он сгенерирован вручную, а не на стороне Zorra, поэтому true',
    102: 'регион',
    103: 'Для проверки кода вы можете использовать метод:',
    104: 'Обратите внимание, что метод check работает только для случаев, где код был сгенерирован автоматически.',
    105: 'Время жизни отправленного кода - 5 минут, после он становится невалидным',
    106: 'В теле запроса нужно передать номер телефона, на который отправлялся звонок и код введенный пользователем, чтобы сверить с номером, который ему звонил.',
    107: 'верифицируемый номер',
    108: 'значение кода из номера, которое ввел пользователь',
    109: 'Пример ответа, если код верный:',
    110: 'Верификация по коду, продиктованному при звонке',
    111: 'На номер, который требуется проверить, будет произведен входящий звонок с купленного вами номера. Владелец номера должен взять трубку и прослушать код, который ему будет продиктован. Далее ему нужно ввести код, который он услышал, и если введен верный код, то номер пользователя - верифицирован.',
    112: 'Важно: для использования данного типа верификации, необходимо иметь хотя бы 1 купленный номер в Zorra.',
    113: 'Перед отправкой запросов необходимо направить, хотя бы один купленный вами номер телефона на использование в верификации. Вы можете использовать сразу несколько номеров.',
    114: 'Отправьте запрос:',
    115: 'Вместо {number_id} - подставьте идентификатор купленного вами номера телефона. С него будут производится звонки.',
    116: 'номер, который нужно верифицировать, обязательный параметр.',
    117: 'вы можете передать в запросе конкретный код, который будет продиктован. Если не передавать этот параметр, то Zorra сама сгенерирует уникальный код размера',
    118: 'параметр указывает какой длины необходимо  сгенерировать код (1-6), если не передан параметр code (по умолчанию size = 6).',
    119: 'идентификатор одного из направленных вами для верификации номеров. Если не передать этот параметр, то номер будет выбран случайно из числа всех направленных.',
    120: 'указывается язык на котором будет продиктован код.',
    121: 'Допустимые значения параметра',
    122: 'русский язык',
    123: 'английский язык',
    124: 'испанский язык',
    125: 'французский язык',
    126: 'итальянский язык',
    127: 'японский язык',
    128: 'вьетнамский язык',
    129: 'филиппинский язык',
    130: 'шведский язык',
    131: 'Пример успешного ответа:',
    132: 'идентификатор запроса верификации',
    133: 'тип верификации',
    134: 'верифицируемый номер',
    135: 'параметр указывающий на то, на чьей стороне был зада code. В данном случае code передавали в запросе, поэтому считаем что он сгенерирован вручную, поэтому true',
    136: 'говорит о том на каком языке был озвучен код',
    137: 'Для проверки кода вы можете использовать метод:',
    138: 'Обратите внимание, что метод check работает только для случаев, где код был сгенерирован автоматически',
    139: 'Время жизни отправленного кода - 5 минут, после он становится невалидным',
    140: 'В теле запроса нужно передать номер телефона, на который отправлялся звонок и код введенный пользователем, чтобы сверить с тем, который ему был продиктован.',
    141: 'Пример успешного ответа, если коды совпадают:',
    142: 'Базы данных',
    143: 'Получить список групп',
    144: 'В Zorra вы можете объединять ваши базы данных в группы для более удобного взаимодействия. Используйте данный метод для получения списка групп БД.',
    145: 'Получить список баз данных',
    146: 'Можно сделать запрос без параметров, тогда в результате вы получите все базы данных, которые есть на вашем аккаунте.',
    147: 'По данному запросу в ответе придут все базы данных из группы с идентификатором 83, отсортированные по идентификатору.',
    148: 'идентификатор группы БД',
    149: 'поле по которому нужно отсортировать',
    150: 'направление сортировки (asc, desk)',
    151: 'Создать базу данных',
    152: 'VIP клиенты',
    153: 'Получить список контактов в базе данных',
    154: 'Вместо {id} - подставьте идентификатор базы данных получателей которой нужно получить.',
    155: 'Обратите внимание, что в ответе применяется пагинация (блок <u>meta</u> в ответе). Вы можете перемещаться по страницам, передавая параметр <u>current_page</u>. А также передать максимальное количество элементов на странице в параметре',
    156: '(не более 500).',
    157: 'Вы можете использовать параметр <u>search</u> для фильтрации результатов по полям number, email, name, last_name.',
    158: 'Создать контакт в БД',
    159: 'Удалить получателя',
    160: 'Вместо {id} - подставьте идентификатор базы данных контакта, вместо {recipient_id} - его идентификатор.',
    161: 'Изменить получателя',
    162: 'Вместо {id} - подставьте идентификатор базы данных контакта, вместо {recipient_id} - его идентификатор.',
    163: 'Передайте в теле запроса поля, которые необходимо изменить и их новые значения.',
    164: 'Просмотр получателя',
    165: 'Вместо {id} - подставьте идентификатор базы данных контакта, вместо {recipient_id} - его идентификатор.',
    166: 'метка_для_получателя',
    167: 'Среднее специальное',
    168: 'HLR запросы',
    169: 'HLR запрос или Home Location Register применяется для анализа статуса телефонного номера определённого абонента. Это позволяет отсеить неактивные номера из ваших баз рассылок.',
    170: 'Для использования HLR запросов, вам необходимо предварительно обратиться в службу поддержки Zorra для подключения этой услуги. Рекомендуем также подготовить URL, на который мы сможем отправить вам результаты ваших запросов в виде постбеков.',
    171: 'Вы можете также обрабатывать файлы таблиц с номерами, загружая их на обработку через личный кабинет, раздел HLR.',
    172: 'Отправка HLR запроса',
    173: 'Вы можете направить в одном запросе сразу массив номеров на проверку.',
    174: 'В ответе вы получите идентификатор запроса, по которому далее можно будет запросить статистику результатов',
    175: 'Получение результатов HLR запросов',
    176: 'В ответе вы получите результаты проверки с пагинацией.',
    177: 'Отправка запроса верификации:',
    178: '',
    dasha: 'Даша',
    andrey: 'Андрей',
    misha: 'Миша',
  }
};